import styled from 'styled-components';

export const Generatemain = styled.div`
    padding : calc(100vw*(13/375)) 0 0 0;
`
export const GenerateTop = styled.div`
    padding : 0 calc(100vw*(17/375)) calc(100vw*(45.5/375)) calc(100vw*(17/375));
`
export const User = styled.h1`
    display: flex;
    align-items: center;
`

export const Userimg = styled.span`
  width: calc(100vw * (40 / 375));
  height: calc(100vw * (40 / 375));
  border: 1px solid #c6c6c6;
  border-radius: 50%;
  object-fit: contain; 
  overflow: hidden;
`
export const UserImgTag = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const Username = styled.p`
    font-size: calc(100vw*(14/375));
    font-weight: bold;
    margin-left :  calc(100vw*(8/375));
`
export const Textbox = styled.input`
    width: 100%;
    padding-top: calc(100vw*(16/375));
    font-size: calc(100vw*(14/375));
    color: #1d1d1d;

    &::placeholder {
        font-size: calc(100vw*(12/375));
        color: #c6c6c6;
    }
`

export const Arrowright = styled.em` 
    display:block;
    width: calc(100vw*(5.3/375));
    height: calc(100vw*(10.6/375));
    object-fit: contain;
    margin-left : calc(100vw*(10.7/375));
`
export const Setlistinner = styled.ul`
    border-bottom: solid  calc(100vw*(1/375)) #d8d8d8;
`
export const Setlist = styled.li`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height : calc(100vw*(43/375));
    border-top: solid  calc(100vw*(1/375)) #d8d8d8;
    padding : 0 calc(100vw*(17/375)) 0;
`
export const Setlistname = styled.span`
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    color: #1d1d1d;
`
export const Setlistcont = styled.span`
    display: flex;
    align-items: center;
    font-size:  calc(100vw*(11/375));
    font-weight: 500;
    color: #989898;
`
export const Setlistdata = styled.em`
    font-size: calc(100vw*(11/375));
    font-weight: 500;
    color: #989898;
`
export const TopInner = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 200;
    width: 100%;
    height: calc(100vw*(51/375));
    display: felx;
    align-items: center;
    padding:0 calc(100vw*(17/375));


`
export const Title = styled.h1`
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
    // margin-left: calc(100vw*(131.2/375));
`

export const Back = styled.span`
    cursor: pointer;
    display:block;
    width: calc(100vw*(9.8/375));
    height: calc(100vw*(16/375));
`
export const Finish = styled.span`
    cursor: pointer;
    display:block;
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    line-height: 2.83;
    color: #ffc036;
    margin-left: calc(100vw*(-38/375));
` 